import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import axios from 'axios'
import Breadcrumb from '../Component/BradeCrum';
import HeaderMobile from '../Component/MobileHader';


// Banner is optional, so render nothing when it is missing or fails to load
const EventImage = ({ src }) => {
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
      setHidden(false);
    }, [src]);

    if (!src || hidden) return null;

    return (
      <img
        src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${src}`}
        alt='img'
        onError={() => setHidden(true)}
        className='whats-new-modal-img'
      />
    );
  };

const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })

const Events = () => {
   const [upcoming, setUpcoming] = useState([])
   const [past, setPast] = useState([])

    useEffect(()=>{
        const fetchData = () => {
            axios.get(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/list-active/event`)
            .then((res)=>{
                // An event happening today still counts as upcoming
                const today = new Date()
                today.setHours(0, 0, 0, 0)

                const data = res.data || []
                setUpcoming(data.filter((d) => new Date(d.EventDate) >= today))
                setPast(data.filter((d) => new Date(d.EventDate) < today).reverse())
            })
            .catch((error)=>{
                console.error(error)
            })
        }
        fetchData()
    window.scrollTo(0, 0);
    },[])

    const renderSection = (heading, list, emptyText) => (
      <Row className='galleryRow'>
        <div className="sub-title text-animation">
          <h6>
            {heading}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={50}
              height={6}
              viewBox="0 0 50 6"
            >
              <path d="M50 3L45 0.113249V5.88675L50 3ZM0 3.5H45.5V2.5H0V3.5Z" />
            </svg>
          </h6>
        </div>
        {list.length === 0 && <p>{emptyText}</p>}
        {list.map((d)=>
          <Col lg={4} className='mb-3' key={d._id}>
            <Link to={`/events/${d._id}`}>
              <Card className='newProductImgCard mb-5 galleryCard'>
                <EventImage src={d.EventImage} />
                <div className='newProductTitle'>
                  {d.Title}
                </div>
                <div className='positionTitle'>
                  <span>Date : </span>{formatDate(d.EventDate)}
                </div>
              </Card>
            </Link>
          </Col>
        )}
      </Row>
    )

  return (
    <React.Fragment>
      <HeaderMobile/>
      <Breadcrumb heading={"Events"} bTitle={"Events"}/>
        <Container>
            {renderSection("Upcoming Events", upcoming, "No upcoming events at the moment.")}
            {renderSection("Past Events", past, "No past events to show.")}
        </Container>
    </React.Fragment>
  )
}

export default Events
